import { EMPTY_CELL, escapeHtml } from './escape-html';

/**
 * The "Issued by" column on the permits lists.
 *
 * TLC issue most permits themselves; a Business Login issues its own. The column
 * answers which is which - a business name where there is one, a dash where TLC
 * issued it. The dash is the meaningful answer, not a missing value.
 *
 * TAKES `unknown`, AND THAT IS LOAD-BEARING. The CRUD decides what to hand a custom
 * column with:
 *
 *     item[colValue] !== undefined ? item[colValue] : item
 *
 * and the API omits null properties entirely - so on a TLC-issued permit there is no
 * `businessName` key at all and the CRUD passes THE WHOLE PERMIT OBJECT instead. A
 * signature of `string | null` is a lie the compiler cannot catch, and `?? ''` does
 * not help because an object is neither null nor undefined. Calling .trim() on it
 * threw inside change detection, which does not fail one cell: Angular abandons the
 * rest of the view, so the list rendered exactly one row and looked like a paging bug.
 *
 * Anything that is not a string is therefore "no business", which is correct for both
 * real cases - the key being absent, and the value being null.
 *
 * The name is escaped because the CRUD paints custom columns through [innerHTML] and
 * a business name is typed by a person. The CRUD does sanitize afterwards, so this is
 * belt and braces rather than the only guard.
 */
export function permitIssuedBy(value: unknown): string {
    const name = typeof value === 'string' ? value.trim() : '';
    return name ? escapeHtml(name) : EMPTY_CELL;
}
